import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CheckoutReplenishmentFormService } from '@spartacus/checkout/scheduled-replenishment/components';
import { EventService, OccEndpointsService } from '@spartacus/core';
import { ORDER_TYPE, ScheduleReplenishmentForm } from '@spartacus/order/root';
import { BehaviorSubject, EMPTY, Observable } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class GenCheckoutReplenishmentFormService extends CheckoutReplenishmentFormService {

  override defaultFormData: ScheduleReplenishmentForm = {};

  constructor(
    protected override eventService: EventService,
    private occEndpoints: OccEndpointsService,
    private httpClient: HttpClient,
  ) {
    super(eventService);
  }

  scheduleGeneracReplenishmentFormData$: Observable<ScheduleReplenishmentForm> =
    new BehaviorSubject<ScheduleReplenishmentForm>(this.defaultFormData);

  override getScheduleReplenishmentFormData(): Observable<ScheduleReplenishmentForm> {
    return this.scheduleGeneracReplenishmentFormData$;
  }

  override setScheduleReplenishmentFormData(formData: ScheduleReplenishmentForm): void {
    (
      this
        .scheduleGeneracReplenishmentFormData$ as BehaviorSubject<ScheduleReplenishmentForm>
    ).next(formData);
  }

  setReplenishmentOrder(userEmail: string, cartId: string, shippingGroupName: string, manufactureGroupId: string): Observable<any> {
    const url = `${this.occEndpoints.getBaseUrl()}/users/${userEmail}/carts/${cartId}/groups/${shippingGroupName}/manufactures/${manufactureGroupId}/replenishmentSchedule`;
    return this.getScheduleReplenishmentFormData().pipe(
      take(1),
      switchMap(data => this.getOrderType().pipe(map(orderType => [orderType, data]))),
      switchMap(([orderType, data]: any) => {
        if (
          !data.mode ||
          (orderType === ORDER_TYPE.PLACE_ORDER && data.mode === 'REPLENISHMENT')
        ) {
          return EMPTY;
        }

        if (data.mode === 'ONE_TIME') {
          const desiredShipment = {
            mode: data.mode,
            desiredShipmentDate: data.desiredShipmentDate
          };
          return this.httpClient.post<any>(url, desiredShipment);
        }
        return this.httpClient.post<any>(url, data);
      })
    )
  }
}
